export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/82a41b02157d-tooliconlocationpin.jpg',
  },
  title: 'What was the destination of your holiday?',
  placeholderText: 'City, Country',
}
